import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { ProhibitedItemsHeroSection } from '@trashlab/sitesapp/src/organizations/redebins/template/components/prohibited-items/prohibited-items-hero-section';
import { ProhibitedItemsContent } from '@trashlab/sitesapp/src/organizations/redebins/template/components/prohibited-items/prohibited-items-content';
import { ReadyWhenYouAre } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/ready-when-you-are';
import { ServiceAreasSection } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/service-areas-section';

const ProhibitedItemsPage = () => {
  return (
    <>
      <ProhibitedItemsHeroSection />
      <ProhibitedItemsContent />
      <ReadyWhenYouAre />
      <ServiceAreasSection />
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/prohibited-items',
  component: ProhibitedItemsPage,
});

